import { useLocation, Switch, Route } from 'react-router-dom';
import { HpChildComponentProps } from 'components/shared/componentWithModal/componentWithModal';
import { Title } from 'components/layout/header/title';
import { Container } from 'react-bootstrap';
import { useGetScreenSize } from 'utils';
import { ConversionFailure } from './conversionFailure';
import { PATH } from 'interfaces/pathTypes';
import { ConversionSuccess } from './conversionSuccess';
import { ConversionPayment } from './conversionPayment';

export const Conversion = ({ selectedPolicy }: HpChildComponentProps): JSX.Element => {
  const { search } = useLocation();
  const { isMobile, isTablet } = useGetScreenSize();

  const params = new URLSearchParams(search);
  const paymentFrequency = params.get('paymentFrequency');
  const paymentAmount = params.get('paymentAmount');
  const policyDetailsId = params.get('conversionPolicyDetailsId');
  const historyId = params.get('conversionHistoryId');

  return (
    <Container className="page-container" fluid={isMobile || isTablet}>
      <Title title="MANAGE PAYMENTS" icon="credit-card-circle" id="card-update" />
      <div className="payment-container">
        <Switch>
          <Route path={`${PATH.RENEWAL}/payment`}>
            {policyDetailsId && historyId && (
              <ConversionPayment
                selectedPolicy={selectedPolicy}
                paymentFrequency={paymentFrequency}
                paymentAmount={paymentAmount}
                policyDetailsId={policyDetailsId}
                historyId={historyId}
              />
            )}
          </Route>
          <Route path={`${PATH.RENEWAL}/confirmation`}>
            <ConversionSuccess
              paymentPreference={paymentFrequency === 'Yearly' ? 'Yearly' : 'Monthly'}
              selectedPolicy={selectedPolicy}
              amount={paymentAmount ? Number(paymentAmount) : undefined}
            />
          </Route>
          <Route path={`${PATH.RENEWAL}/error`}>
            <ConversionFailure selectedPolicy={selectedPolicy} />
          </Route>
        </Switch>
      </div>
    </Container>
  );
};
